export function stringIsNullOrEmpty(text: string | null | undefined): boolean {
  // '==' so it covers undefined as well!
  return text == null || text === "";
}

export function kebabCaseToCamelCase(kebabAttributeName: string): string {
  return kebabAttributeName.replace(/(-[a-z])/g, (g) => {
    return g.replace("-", "").toUpperCase();
  });
}

export function stringToBoolean(text: string | null | undefined): boolean {
  return !stringIsNullOrEmpty(text) && (text ?? "").toLowerCase() !== "false";
}

export function stringToNumber(
  text: string | null | undefined
): number | false {
  return !stringIsNullOrEmpty(text) && !isNaN(Number(text))
    ? Number(text)
    : false;
}

export function stringToJson(text: string | object | null | undefined): any {
  if (stringIsNullOrEmpty(text as string)) return;
  if (typeof text === "object") return text;
  try {
    return text ? JSON.parse(text) : undefined;
  } catch (error) {
    console.log(error);
  }
}

export function StringToType(text: string | null | undefined): any {
  if (stringIsNullOrEmpty(text)) return;

  switch (text) {
    case "true":
      return true;
    case "false":
      return false;
    default:
      try {
        return JSON.parse(text ?? "");
      } catch (err) {
        console.log(err);
        return stringToNumber(text);
      }
  }
}

// Optional helper — uncomment if needed:
// export function getIdFromAnchor(hash: string): string {
//   const index = hash.indexOf("#");
//   return index > -1 ? hash.substring(index + 1) : hash;
// }
